import { settings } from '../store/settings.store';

export function addStyleSettings()  {
   
  const accentColor = settings.businessSettings?.widgetLayoutSettings?.accentColor ?? '#0000ff';
  const warnColor = settings.businessSettings?.widgetLayoutSettings?.warnColor ?? '#db0e09';

  return { 
    '--tambr-accent-color': accentColor,
    '--tambr-accent-color-opacity': accentColor + 10,

    '--tambr-warn-color': warnColor,
    '--tambr-warn-color-opacity': warnColor + 10
  };

}